import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { ContentLayout } from '../../_NEXT_components/ContentLayout';
import { ConfirmationCallCodeForm } from '../../_NEXT_components/ConfirmationCallCodeForm';
import { isValidCode } from '../../utils/validation';
import { trackPhoneAuthCallSwitchToSmsClick } from '../../utils/tracking';
var PIN_INPUT_LENGTH = 4;
export var PhoneAuthValidateCallFormContainer = function PhoneAuthValidateCallFormContainer(_ref) {
  var hasCodeError = _ref.hasCodeError,
      codeErrorRaw = _ref.codeError,
      isSubmitting = _ref.isSubmitting,
      smsTimeout = _ref.smsTimeout,
      onSwitchToSms = _ref.onSwitchToSms,
      registerOrAuthorize = _ref.registerOrAuthorize;
  var codeSendTimestampRef = React.useRef(new Date().getTime());

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isChanged = _React$useState2[0],
      setChanged = _React$useState2[1];

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      code = _React$useState4[0],
      setCode = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isSmsTimeoutFinished = _React$useState6[0],
      setSendSmsAvailable = _React$useState6[1];

  var isCodeInvalid = !isChanged && hasCodeError;
  var isSendSmsAvailable = !isSubmitting && isSmsTimeoutFinished;
  var codeError = !isChanged ? codeErrorRaw : '';
  var handleSmsTimeoutExpired = React.useCallback(function () {
    setSendSmsAvailable(true);
  }, []);
  var handleSwitchToSms = React.useCallback(function () {
    trackPhoneAuthCallSwitchToSmsClick();
    onSwitchToSms();
  }, [onSwitchToSms]);
  var handleChangeCode = React.useCallback(function (value) {
    var newValue = value.reduce(function (acc, item, index) {
      acc[index] = item.replace(/\D/gi, '').slice(0, 1);
      return acc;
    }, []).splice(0, PIN_INPUT_LENGTH);
    setChanged(true);
    setCode(newValue);
  }, []);
  var handleSubmit = React.useCallback(function () {
    var normalizedCode = code.join('');

    if (!isValidCode(normalizedCode)) {
      return;
    }

    registerOrAuthorize(normalizedCode);
    setChanged(false);
  }, [code, registerOrAuthorize]);
  return /*#__PURE__*/React.createElement(ContentLayout, null, /*#__PURE__*/React.createElement(ConfirmationCallCodeForm, {
    code: code,
    codeLength: PIN_INPUT_LENGTH,
    codeError: codeError,
    submitButtonText: "\u0412\u043E\u0439\u0442\u0438",
    isCodeInvalid: isCodeInvalid,
    isSubmitting: isSubmitting,
    isSendSmsAvailable: isSendSmsAvailable,
    smsTimeout: smsTimeout,
    codeSendTimestamp: codeSendTimestampRef.current,
    onSmsTimeoutExpired: handleSmsTimeoutExpired,
    onCodeChange: handleChangeCode,
    onSwitchToSms: handleSwitchToSms,
    onSubmit: handleSubmit
  }));
};
PhoneAuthValidateCallFormContainer.displayName = 'PhoneAuthValidateCallFormContainer';